import axios from 'axios';

if (typeof window !== 'undefined') {
  const csrfToken = (document.querySelector("[name='csrf-token']") as HTMLMetaElement).content;
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
}

export const api = axios.create({
  baseURL: '/',
  withCredentials: true,
});

api.interceptors.response.use((response) => {
  const gaEventHeader = response.headers['x-ga-event'];
  if (gaEventHeader && (window as any).trackEvent) {
    try {
      const event = JSON.parse(gaEventHeader);
      (window as any).trackEvent(event.name, event.params);
    } catch (e) {
      console.error('Failed to parse GA event header from axios', e);
    }
  }
  return response;
});

export default api;
